import React from 'react'
import './BurgerMenuButton.scss'

const BurgerMenuButton = ({open, setOpen}) => {

    const burgerHandler = () => {
        setOpen(!open)
    }
    
    return (
        <div className='burger-menu-button' onClick={burgerHandler}>
            <div />
            <div />
            <div />
        </div>
    )
}

export default BurgerMenuButton